module.exports = __webpack_public_path__ + "f93afd4efd966433e3c2a3eb54e55c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/tutorial/3.png
// module id = 1613
// module chunks = 0